import { styled as styledMUI } from '@mui/material/styles';
import { Button } from '@mui/material';
import { THEME_COLORS } from '../common/colors';

const PrimaryButton = styledMUI(Button)(
  ({
    color = '#fff',
    backgroundColor = THEME_COLORS.primary,
    hoverColor = THEME_COLORS.primaryHover,
    width = '190px',
  }) => ({
    width,
    color,
    textTransform: 'uppercase',
    fontWeight: '700',
    fontSize: '14px',
    backgroundColor: backgroundColor,
    borderRadius: '32px',
    boxShadow: 'unset',
    '&:hover': {
      backgroundColor: hoverColor,
    },
  }),
);

export default PrimaryButton;
